module.exports = __webpack_public_path__ + "img/json-description-box.73399853.png";